import { Navigate } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';

export const PathLogout = ({ children }) => {
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const menuActive = useSelector((state) => state.menu?.activeMenu, shallowEqual);

  if (user) {
    return <Navigate to={menuActive?.url ? `/${menuActive.url}` : '/dashboard'} replace />;
  }

  return children;
};
